var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-signup-order pb24 bc-cCF5" }, [
    _c("div", { staticClass: "flex space-between w1200 mt24 align-left" }, [
      _c("div", { staticClass: "w100p bc-cCFF" }, [
        _c(
          "div",
          { staticClass: "mt24 ml32 mr32 mb32" },
          [
            _c("div", { staticClass: "fs24 mb24" }, [
              _vm._v(_vm._s(_vm.language().tit_order_form)),
            ]),
            _c(
              "div",
              {
                staticClass: "bc-cCFA rtl4 rtr4 rbl4 rbr4 pt24 pl24 pr24 pb24",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "mb12 fw500 fs20 ellipsis lineClamp2 word-break",
                  },
                  [
                    _c(
                      "yxtf-tag",
                      {
                        staticClass: "pl7 pr7 fs14 relative top-1",
                        attrs: {
                          coverType: "blue",
                          size: "small",
                          type: "info",
                        },
                      },
                      [_vm._v(_vm._s(_vm.data.appName))]
                    ),
                    _c("span", { attrs: { title: _vm.data.projectName } }, [
                      _vm._v(_vm._s(_vm.data.projectName)),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex space-between rtl4 rtr4 rbl4 rbr4" },
                  [
                    _c(
                      "div",
                      { staticClass: "w50p-12" },
                      [
                        _c("div", { staticClass: "mb8 c-cC8C relative" }, [
                          _c("span", { staticClass: "justify ellipsis" }, [
                            _vm._v(_vm._s(_vm.language().lbl_admin)),
                          ]),
                          _c("span", [_vm._v("：")]),
                          _c(
                            "span",
                            { staticClass: "c-cC26" },
                            [
                              _c("yxtbiz-user-name", {
                                attrs: {
                                  slot: "content",
                                  name:
                                    (_vm.data.owners || [])
                                      .map(function (_) {
                                        return _.fullname
                                      })
                                      .join("、") || "--",
                                  split: "、",
                                },
                                slot: "content",
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._l(_vm.extendedInfo, function (info, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              class: "c-cC8C relative " + (index ? "mt8" : ""),
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "absolute top0 inline-block w58 justify",
                                },
                                [_vm._v(_vm._s(info.label))]
                              ),
                              _c(
                                "span",
                                { staticClass: "absolute top0 left58" },
                                [_vm._v("：")]
                              ),
                              _c("span", { staticClass: "c-cC26 block pl70" }, [
                                _vm._v(_vm._s(info.value || "--")),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm.data.pointPrice
                      ? _c(
                          "div",
                          { staticClass: "w50p-12 align-right flex-end" },
                          [
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "mb8 c-cC8C relative" },
                                [
                                  _c("span", { staticClass: "inline-block" }, [
                                    _vm._v(
                                      _vm._s(_vm.language().lbl_total_cost)
                                    ),
                                  ]),
                                  _c("span", { staticClass: "inline-block" }, [
                                    _vm._v("："),
                                  ]),
                                  _c(
                                    "span",
                                    { staticClass: "inline-block c-cC26" },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "d-integral relative top-5",
                                        attrs: {
                                          src:
                                            _vm.staticBaseUrl +
                                            "assets/141df7bc/85e5b524/a27406.svg",
                                          alt: "",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "ml4 c-cC26 fs24 fw500",
                                        },
                                        [_vm._v(_vm._s(_vm.data.pointPrice))]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "ml4 c-cC75 relative top-3",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.language().msg_integral)
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm.points.totalMallPoint &&
                              !(_vm.users && _vm.users.length)
                                ? _c(
                                    "div",
                                    { staticClass: "c-cC8C relative" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "inline-block" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.language()
                                                .lbl_available_points
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "inline-block" },
                                        [_vm._v("：")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "inline-block c-cC26" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.points.totalMallPoint.toLocaleString()
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        )
                      : _c(
                          "div",
                          { staticClass: "w50p-12 align-right flex-end" },
                          [
                            _c(
                              "div",
                              { staticClass: "c-cC8C relative top-2" },
                              [
                                _c("span", { staticClass: "inline-block" }, [
                                  _vm._v(_vm._s(_vm.language().lbl_total_cost)),
                                ]),
                                _c("span", { staticClass: "inline-block" }, [
                                  _vm._v("："),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "inline-block c-cC59 fw500 fs20",
                                  },
                                  [_vm._v(_vm._s(_vm.language().msg_free))]
                                ),
                              ]
                            ),
                          ]
                        ),
                  ]
                ),
              ]
            ),
            _vm.users && _vm.users.length
              ? [
                  _c("div", { staticClass: "mt32" }, [
                    _c("div", { staticClass: "ml24 fs16 c-cC26 mb8" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.language().tit_registration_list)),
                      ]),
                    ]),
                    _vm.data.needAttach
                      ? _c("div", { staticClass: "ml24 fs14 c-cC75 mb10" }, [
                          _vm._v(_vm._s(_vm.language().msg_upload_demands)),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "w100p clearfix" },
                      _vm._l(_vm.userList, function (user, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            class:
                              "pl24 relative pull-" +
                              (index % 2 === 0 ? "left" : "right") +
                              " w50p-48 bc-cCF5-hover " +
                              (_vm.ruleResultUsers[user.id] ||
                              (_vm.extraConditions &&
                                _vm.extraConditions[user.id])
                                ? "bc-FAFAFA"
                                : ""),
                          },
                          [
                            _c("div", { staticClass: "h64 bb1 mr16" }, [
                              _c(
                                "span",
                                { staticClass: "inline-block mt10" },
                                [
                                  _c("yxtf-portrait", {
                                    attrs: {
                                      size: "small",
                                      imgUrl: user.imgUrl,
                                      username: user.fullname,
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "inline-block ml8" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "fs14 c-cC26 h22 inline-block",
                                        },
                                        [
                                          _c(
                                            "yxt-tooltip",
                                            {
                                              staticClass:
                                                "w150 ellipsis inline-block",
                                              attrs: {
                                                effect: "dark",
                                                placement: "top",
                                                "open-filter": true,
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _c("yxtbiz-dept-name", {
                                                    attrs: {
                                                      name:
                                                        user.fullname || "--",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content",
                                                },
                                                [
                                                  _c("yxtbiz-dept-name", {
                                                    attrs: {
                                                      name:
                                                        user.fullname || "--",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "fs12 c-cC8C relative top-6 h20",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.points.userId === user.id
                                                ? _vm.language()
                                                    .lbl_self_registration
                                                : _vm.language().msg_all
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("i", {
                                class:
                                  (_vm.ruleResultUsers[user.id] ||
                                  (_vm.extraConditions &&
                                    _vm.extraConditions[user.id])
                                    ? "x-open"
                                    : "x-close") +
                                  " absolute yxt-icon-close wh16 c-cC8C right20 fs16 top25 pointer",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.del(user.id)
                                  },
                                },
                              }),
                              _vm.data.needAttach &&
                              (!_vm.ruleResultUsers[user.id] ||
                                (_vm.extraConditions &&
                                  !_vm.extraConditions[user.id]))
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "fs14 pull-right c-cC436BFF pointer mr46 pointer lh64 h64",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.openFile(user)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          user.attachments &&
                                            user.attachments.length
                                            ? _vm.language()
                                                .btn_view_attachments +
                                                "（" +
                                                user.attachments.length +
                                                "）"
                                            : _vm.language()
                                                .btn_upload_attachments
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "fs12 c-cC8C pull-right mr24 pointer lh64 h64",
                                },
                                [
                                  _vm.ruleResultUsers[user.id] ||
                                  (_vm.extraConditions &&
                                    _vm.extraConditions[user.id])
                                    ? _c(
                                        "yxt-popover",
                                        {
                                          attrs: {
                                            placement: "top",
                                            "max-width": "560",
                                            "max-height": "300",
                                            trigger: "hover",
                                            "visible-arrow": true,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "reference" },
                                              slot: "reference",
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  width: "16px",
                                                  height: "16px",
                                                  src:
                                                    _vm.$staticBaseUrl +
                                                    "assets/141df7bc/74029ffb/a95b30.svg",
                                                },
                                              }),
                                              _vm.ruleResultUsers[user.id] ||
                                              (_vm.extraConditions &&
                                                _vm.extraConditions[user.id])
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "relative top1 ml2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.language().lbl_non
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "yxtbiz-signup" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "mah276" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "c-cC26 fs16 mb4 fw500",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.language().tit_non
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "c-cC75 fs14",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.data
                                                            .requireCount === 1
                                                            ? _vm.language()
                                                                .lbl_check_con1
                                                            : _vm.language()
                                                                .lbl_check_con0
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._l(
                                                    _vm.ruleResultUsers[
                                                      user.id
                                                    ],
                                                    function (item, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: index,
                                                          class:
                                                            "fs14 c-cC26 " +
                                                            (index === 0
                                                              ? "mt16"
                                                              : "mt24"),
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "dot bc-cCD8 relative top-1",
                                                          }),
                                                          item.ruleCode ===
                                                          "cers"
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.ruleName
                                                                  ) +
                                                                    "（" +
                                                                    _vm._s(
                                                                      item.requireCount ===
                                                                        0
                                                                        ? _vm.language()
                                                                            .lbl_check_concer00
                                                                        : _vm.language()
                                                                            .lbl_check_concer1
                                                                    ) +
                                                                    "）"
                                                                ),
                                                              ])
                                                            : item.ruleCode ===
                                                              "exams"
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.ruleName
                                                                  ) +
                                                                    "（" +
                                                                    _vm._s(
                                                                      item.requireCount ===
                                                                        0
                                                                        ? _vm.language()
                                                                            .lbl_check_conexam00
                                                                        : _vm.language()
                                                                            .lbl_check_conexam1
                                                                    ) +
                                                                    "）"
                                                                ),
                                                              ])
                                                            : _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.ruleName
                                                                  )
                                                                ),
                                                              ]),
                                                          _c("br"),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "c-cC75 fs14 ml16 inline-block",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.ruleValueInfo
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  _vm.extraConditions &&
                                                  _vm.extraConditions[
                                                    user.id
                                                  ] &&
                                                  _vm.extraConditions[user.id]
                                                    .length > 0
                                                    ? _vm._l(
                                                        _vm.extraConditions[
                                                          user.id
                                                        ],
                                                        function (item, index) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: index,
                                                              class:
                                                                "fs14 c-cC26 " +
                                                                (index === 0 &&
                                                                !_vm
                                                                  .ruleResultUsers[
                                                                  user.id
                                                                ]
                                                                  ? "mt16"
                                                                  : "mt24"),
                                                            },
                                                            [
                                                              _c("span", {
                                                                staticClass:
                                                                  "dot bc-cCD8 relative top-1",
                                                              }),
                                                              item.ruleCode ===
                                                              "cers"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.ruleName
                                                                      ) +
                                                                        "（" +
                                                                        _vm._s(
                                                                          item.requireCount ===
                                                                            0
                                                                            ? _vm.language()
                                                                                .lbl_check_concer00
                                                                            : _vm.language()
                                                                                .lbl_check_concer1
                                                                        ) +
                                                                        "）"
                                                                    ),
                                                                  ])
                                                                : item.ruleCode ===
                                                                  "exams"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.ruleName
                                                                      ) +
                                                                        "（" +
                                                                        _vm._s(
                                                                          item.requireCount ===
                                                                            0
                                                                            ? _vm.language()
                                                                                .lbl_check_conexam00
                                                                            : _vm.language()
                                                                                .lbl_check_conexam1
                                                                        ) +
                                                                        "）"
                                                                    ),
                                                                  ])
                                                                : _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.ruleName
                                                                      )
                                                                    ),
                                                                  ]),
                                                              _c("br"),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "c-cC75 fs14 ml16 inline-block",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.ruleValueInfo
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                    _c("div", { staticClass: "ml24 w100p c-cC59 fs12 mt16" }, [
                      _c("div", {
                        staticClass: "inline-block",
                        domProps: { innerHTML: _vm._s(_vm.text) },
                      }),
                      _c(
                        "span",
                        {
                          staticClass:
                            "c-cC436BFF fs12 inline-block ml16 pointer",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.delAll.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.language().mgs_removeall))]
                      ),
                    ]),
                  ]),
                ]
              : [
                  _vm.data.needSurvey
                    ? _c("div", { staticClass: "ml24 mt32" }, [
                        _c("div", { staticClass: "fs16 c-cC26 mb8" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.language().tit_registration_form)
                            ),
                          ]),
                          _vm._m(0),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "bc-cCF5 pt12 pb12 pl16 pr16 rtl4 rtr4 rbl4 rbr4",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "relative pl24" },
                              [
                                _c("yxtf-svg", {
                                  staticClass: "absolute left0 top-2",
                                  attrs: {
                                    width: "24px",
                                    height: "24px",
                                    "icon-class": "icons/f_proj-research",
                                  },
                                }),
                                _c("span", { staticClass: "fs14 c-cC59 ml4" }, [
                                  _vm._v(_vm._s(_vm.data.surveyTemplateName)),
                                ]),
                                !_vm.needSurveyValue
                                  ? _c(
                                      "yxtf-button",
                                      {
                                        staticClass: "pull-right",
                                        attrs: { size: "small", plain: "" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.openSurvey.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.language().btn_fill_out_the_form
                                          )
                                        ),
                                      ]
                                    )
                                  : _c("yxtf-svg", {
                                      staticClass: "relative top4 pull-right",
                                      attrs: {
                                        width: "16px",
                                        height: "16px",
                                        "icon-class":
                                          "icons/f_feedback-success",
                                      },
                                    }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm.data.needAttach
                    ? _c("div", { staticClass: "ml24 mt32" }, [
                        _c("div", { staticClass: "fs16 c-cC26 mb8" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.language().tit_upload_attachments)
                            ),
                          ]),
                          _vm._m(1),
                        ]),
                        _c("div", [
                          _c("div", { staticClass: "fs14 h24 c-cC8C mb16" }, [
                            _vm._v(
                              _vm._s(
                                _vm.language().msg_upload_info.replace(
                                  "$types",
                                  _vm.data.attachTypeOptionList
                                    .map(function (_) {
                                      return {
                                        1: _vm.language().lbl_file,
                                        2: _vm.language().lbl_picture,
                                        3: _vm.language().lbl_video,
                                      }[_]
                                    })
                                    .join("、")
                                )
                              )
                            ),
                          ]),
                          _vm.attachments.length < _vm.uploadConfig.max
                            ? _c(
                                "div",
                                { staticClass: "wh120 center pointer" },
                                [
                                  _c("yxtbiz-upload", {
                                    staticClass: "wh120",
                                    attrs: {
                                      "icon-class": "plus",
                                      "config-key": "AttachConfigKey",
                                      filters: _vm.filters,
                                      "app-code": _vm.uploadConfig.appCode,
                                      "module-name":
                                        _vm.uploadConfig.moduleName,
                                      "function-name":
                                        _vm.uploadConfig.functionName,
                                      md5: "",
                                      "before-upload": _vm.beforeUpload,
                                      "on-progress": _vm.onProgress,
                                      "on-uploaded": _vm.onUploaded,
                                      "on-error": _vm.onError,
                                      drag: true,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "c-cC75 fs14 mt16" },
                            _vm._l(_vm.attachments, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  class:
                                    "w50p-14 mb8 h40 lh40 bc-cCF5-hover rtl4 rtr4 rbl4 rbr4 inline-block " +
                                    (index % 2 === 1 ? "ml28" : ""),
                                },
                                [
                                  _c("yxtf-svg", {
                                    staticClass:
                                      "wh24 relative left-3 top4 ml8",
                                    attrs: {
                                      "icon-class":
                                        "icons/" +
                                        _vm.getIconName(item.fileClass),
                                    },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "fs14 c-cC26 relative top6 h20 inline-block ellipsis w148-max",
                                      attrs: {
                                        title:
                                          item.name &&
                                          item.name.replace(/\.[^.]+$/, ""),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.name &&
                                            item.name.replace(/\.[^.]+$/, "")
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "fs14 c-cC8C relative top1",
                                    },
                                    [
                                      _vm._v(
                                        "." +
                                          _vm._s(
                                            item.name &&
                                              item.name.split(".").pop()
                                          )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "fs14 c-cC8C ml8 relative top1",
                                    },
                                    [_vm._v(_vm._s(_vm.getSize(item.size)))]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "x-close fs14 c-cC8C ml8 pull-right mr16 pointer",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.close(item.uuid)
                                        },
                                      },
                                    },
                                    [
                                      _c("yxtf-svg", {
                                        staticClass: "relative top4",
                                        attrs: {
                                          width: "20px",
                                          height: "20px",
                                          "icon-class": "delete-1",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            !item.error &&
                                            item.progress !== 100,
                                          expression:
                                            "!item.error && item.progress !== 100",
                                        },
                                      ],
                                      staticClass:
                                        "fs14 c-cC8C ml8 relative top2 mr18 pull-right wh159-40",
                                    },
                                    [
                                      _c(
                                        "yxtf-progress",
                                        {
                                          staticClass: "relative top-3",
                                          attrs: { percentage: item.progress },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "c-cC75",
                                              attrs: { slot: "content" },
                                              slot: "content",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(item.progress) + "%"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    {
                                      class:
                                        "fs12 ml8 relative top1 pull-right mr12 w48 " +
                                        (!item.error ? "c-cC8C" : "c-cCRed"),
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.error
                                            ? _vm.language().lbl_upload_failed
                                            : item.progress === 100
                                            ? _vm.language().lbl_upload_success
                                            : _vm.language().lbl_uploading_now
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
            _c(
              "div",
              {
                class:
                  _vm.data.needAttach || _vm.data.needSurvey
                    ? "ml24 mt32 justify-content-center inline-flex w100p"
                    : "ml24 mt32 justify-content-center inline-flex w100p",
              },
              [
                _c(
                  "yxtf-button",
                  {
                    attrs: {
                      size: "larger2",
                      type: "primary",
                      disabled:
                        _vm.needAttachDisabled ||
                        (_vm.userList.length
                          ? !!_vm.ruleResult.failNum
                          : _vm.signupType === "all"
                          ? true
                          : false),
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.openSponsor(null)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.language().btn_ok))]
                ),
              ],
              1
            ),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "yxtf-form-item__required relative top-4" },
      [_c("i", { staticClass: "required-dot" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "yxtf-form-item__required relative top-4" },
      [_c("i", { staticClass: "required-dot" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }